export class ComponentModel {
  componentName: string;
  componentId: number;
  tenantId: number;
  tenantName: string;
  componentDbConnStr: string;
  componentDbConnStrValue: string;
  componentDbOdbcConnStr: string;
  componentDbOdbcConnStrValue: string;
  createdBy: string;
  createdTime: string;
  lastModifiedBy: string;
  lastModifiedTime: string;
  masterComponentId: number;
  componentTargetConfigurations: ComponentTargetConfigurations[];
}

export class ComponentTargetConfigurations {
  id: number;
  targetTypeId: number;
  tenantId: number;
  componentId: number;
  targetTableName: string;
  targetDbConnStr: string;
  targetDbConnStrValue: string;
  targetDbOdbcConnStr: string;
  targetDbOdbcConnStrValue: string;
  cosmosDbKey: string;
  cosmosDbKeyValue: string;
  cosmosDbApiUrl: string;
  cosmosDbApiUrlValue: string;
  cosmosDbName: string;
}
